// removed by extract-text-webpack-plugin
module.exports = {"sdgLegend":"sdgLegend__3fL7m","rightSDG":"rightSDG__2Brdt","sdgImage":"sdgImage__Dw40b","leftSDG":"leftSDG__3Wltu","sdgItem":"sdgItem__Tl_sJ","sdgPercent":"sdgPercent__zxIz9","imageItem":"imageItem__3DcL7","othersItem":"othersItem__2evrH","sdgImageTop":"sdgImageTop__3Fyna","sdgName":"sdgName__2SR9U","sdgItemRight":"sdgItemRight__jGCMx","sdgTooltip":"sdgTooltip__2dlSn","mainPercentageWrapper":"mainPercentageWrapper__32UoI"};


//////////////////
// WEBPACK FOOTER
// ./components/paSunburstChart/components/sdgLegend/style.scss
// module id = jUQA
// module chunks = 0